(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7971],{

/***/ 4312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "chevron-down_svg__h-5 chevron-down_svg__w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M5.293 7.293a1 1 0 0 1 1.414 0L10 10.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 0-1.414z",
    clipRule: "evenodd"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgChevronDown);

/***/ }),

/***/ 1997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgDotsHorizontal = function SvgDotsHorizontal(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "dots-horizontal_svg__h-5 dots-horizontal_svg__w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M6 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm6 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgDotsHorizontal);

/***/ }),

/***/ 8405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "trash_svg__h-6 trash_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19 7-.867 12.142A2 2 0 0 1 16.138 21H7.862a2 2 0 0 1-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3M4 7h16"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgTrash);

/***/ }),

/***/ 877:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new",
      function () {
        return __webpack_require__(5596);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const CompactButton = (param)=>{
    let { icon: Icon , children , onClick  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: "inline-flex h-5 w-5 items-center justify-center rounded-full bg-slate-100 text-slate-400 transition-colors hover:bg-slate-200 active:bg-slate-300 active:text-slate-500",
        onClick: onClick,
        children: Icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
            className: "h-3 w-3"
        }) : children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CompactButton);


/***/ }),

/***/ 5664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



const DateCard = (param)=>{
    let { annotation , className , day , dow , month  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("relative inline-flex h-14 w-14 items-center justify-center rounded-md border border-slate-200 bg-white p-1 text-center", className),
        children: [
            annotation ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute -top-3 -right-3 z-20",
                children: annotation
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    dow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "-mt-3 bg-white text-center text-xs text-slate-400",
                        children: dow
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-center text-xl font-bold leading-none",
                        children: day
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-center text-xs font-semibold uppercase leading-normal text-slate-500",
                        children: month
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DateCard);


/***/ }),

/***/ 13:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _icons_spinner_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8374);




const FullPageLoader = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(" flex h-full items-center justify-center", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-primary-500 flex items-center rounded-lg px-4 py-3 text-sm text-white shadow-sm",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_spinner_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: "mr-3 h-5 animate-spin"
                }),
                children
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullPageLoader);


/***/ }),

/***/ 9827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ styleMenuItem; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6010);

const styleMenuItem = (param)=>{
    let { active , selected  } = param;
    return (0,clsx__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("menu-item", {
        "font-medium": selected,
        "bg-blue-50": active
    });
};


/***/ }),

/***/ 6310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ time_zone_picker; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom-interactions/dist/floating-ui.react-dom-interactions.esm.js + 2 modules
var floating_ui_react_dom_interactions_esm = __webpack_require__(4287);
// EXTERNAL MODULE: ./node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
var floating_ui_core_browser_min = __webpack_require__(8301);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/combobox/combobox.js
var combobox = __webpack_require__(4789);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/spacetime/src/index.js + 60 modules
var src = __webpack_require__(7461);
// EXTERNAL MODULE: ./node_modules/timezone-soft/builds/timezone-soft.mjs
var timezone_soft = __webpack_require__(9485);
// EXTERNAL MODULE: ./src/components/icons/chevron-down.svg
var chevron_down = __webpack_require__(4312);
// EXTERNAL MODULE: ./src/components/menu-styles.ts
var menu_styles = __webpack_require__(9827);
;// CONCATENATED MODULE: ./src/components/time-zone-picker/time-zones.json
var time_zones_namespaceObject = JSON.parse('{"Pacific/Midway":"Midway Island, Samoa","Pacific/Honolulu":"Hawaii","America/Juneau":"Alaska","America/Boise":"Mountain Time","America/Dawson":"Dawson, Yukon","America/Chihuahua":"Chihuahua, La Paz, Mazatlan","America/Phoenix":"Arizona","America/Chicago":"Central Time","America/Regina":"Saskatchewan","America/Mexico_City":"Guadalajara, Mexico City, Monterrey","America/Belize":"Central America","America/Detroit":"Eastern Time","America/Bogota":"Bogota, Lima, Quito","America/Caracas":"Caracas, La Paz","America/Santiago":"Santiago","America/St_Johns":"Newfoundland and Labrador","America/Sao_Paulo":"Brasilia","America/Tijuana":"Tijuana","America/Montevideo":"Montevideo","America/Argentina/Buenos_Aires":"Buenos Aires, Georgetown","America/Godthab":"Greenland","America/Los_Angeles":"Pacific Time","Atlantic/Azores":"Azores","Atlantic/Cape_Verde":"Cape Verde Islands","GMT":"UTC","Europe/London":"Edinburgh, London","Europe/Dublin":"Dublin","Europe/Lisbon":"Lisbon","Africa/Casablanca":"Casablanca, Monrovia","Atlantic/Canary":"Canary Islands","Europe/Belgrade":"Belgrade, Bratislava, Budapest, Ljubljana, Prague","Europe/Sarajevo":"Sarajevo, Skopje, Warsaw, Zagreb","Europe/Brussels":"Brussels, Copenhagen, Madrid, Paris","Europe/Amsterdam":"Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna","Africa/Algiers":"West Central Africa","Europe/Bucharest":"Bucharest","Africa/Cairo":"Cairo","Europe/Helsinki":"Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius","Europe/Athens":"Athens, Minsk","Asia/Jerusalem":"Jerusalem","Africa/Harare":"Harare, Pretoria","Europe/Moscow":"Istanbul, Moscow, St. Petersburg, Volgograd","Asia/Kuwait":"Kuwait, Riyadh","Africa/Nairobi":"Nairobi","Asia/Baghdad":"Baghdad","Asia/Tehran":"Tehran","Asia/Dubai":"Abu Dhabi, Muscat","Asia/Baku":"Baku, Tbilisi, Yerevan","Asia/Kabul":"Kabul","Asia/Yekaterinburg":"Ekaterinburg","Asia/Karachi":"Islamabad, Karachi, Tashkent","Asia/Kolkata":"Chennai, Kolkata, Mumbai, New Delhi","Asia/Kathmandu":"Kathmandu","Asia/Dhaka":"Astana, Dhaka","Asia/Colombo":"Sri Jayawardenepura","Asia/Almaty":"Almaty, Novosibirsk","Asia/Rangoon":"Yangon Rangoon","Asia/Bangkok":"Bangkok, Hanoi, Jakarta","Asia/Krasnoyarsk":"Krasnoyarsk","Asia/Shanghai":"Beijing, Chongqing, Hong Kong SAR, Urumqi","Asia/Kuala_Lumpur":"Kuala Lumpur, Singapore","Asia/Taipei":"Taipei","Australia/Perth":"Perth","Asia/Irkutsk":"Irkutsk, Ulaanbaatar","Asia/Seoul":"Seoul","Asia/Tokyo":"Osaka, Sapporo, Tokyo","Asia/Yakutsk":"Yakutsk","Australia/Darwin":"Darwin","Australia/Adelaide":"Adelaide","Australia/Sydney":"Canberra, Melbourne, Sydney","Australia/Brisbane":"Brisbane","Australia/Hobart":"Hobart","Asia/Vladivostok":"Vladivostok","Pacific/Guam":"Guam, Port Moresby","Asia/Magadan":"Magadan, Solomon Islands, New Caledonia","Asia/Kamchatka":"Kamchatka, Marshall Islands","Pacific/Fiji":"Fiji Islands","Pacific/Auckland":"Auckland, Wellington","Pacific/Tongatapu":"Nuku\'alofa"}');
;// CONCATENATED MODULE: ./src/components/time-zone-picker/time-zone-picker.tsx










const useTimeZones = ()=>{
    const options = react.useMemo(()=>{
        return Object.entries(time_zones_namespaceObject).reduce((selectOptions, zone)=>{
            const now = src/* default.now */.Z.now(zone[0]);
            const tz = now.timezone();
            let label = "";
            const min = tz.current.offset * 60;
            const hr = "".concat(min / 60 ^ 0, ":") + (min % 60 === 0 ? "00" : Math.abs(min % 60));
            const prefix = "(GMT".concat(hr.includes("-") ? hr : "+".concat(hr), ") ").concat(zone[1]);
            label = prefix;
            selectOptions.push({
                value: tz.name,
                label: label,
                offset: tz.current.offset
            });
            return selectOptions;
        }, []).sort((a, b)=>a.offset - b.offset);
    }, []);
    const findFuzzyTz = react.useCallback((zone)=>{
        let currentTime = src/* default.now */.Z.now("GMT");
        try {
            currentTime = src/* default.now */.Z.now(zone);
        } catch (err) {
            throw new Error("Invalid time zone: zone");
        }
        return options.filter((tz)=>tz.offset === currentTime.timezone().current.offset).map((tz)=>{
            let score = 0;
            if (currentTime.timezones[tz.value.toLowerCase()] && !!currentTime.timezones[tz.value.toLowerCase()].dst === currentTime.timezone().hasDst) {
                if (tz.value.toLowerCase().indexOf(currentTime.tz.substring(currentTime.tz.indexOf("/") + 1)) !== -1) {
                    score += 8;
                }
                if (tz.label.toLowerCase().indexOf(currentTime.tz.substring(currentTime.tz.indexOf("/") + 1)) !== -1) {
                    score += 4;
                }
                if (tz.value.toLowerCase().indexOf(currentTime.tz.substring(0, currentTime.tz.indexOf("/")))) {
                    score += 2;
                }
                score += 1;
            } else if (tz.value === "GMT") {
                score += 1;
            }
            return {
                tz,
                score
            };
        }).sort((a, b)=>b.score - a.score).map((param)=>{
            let { tz  } = param;
            return tz;
        })[0];
    }, [
        options
    ]);
    return react.useMemo(()=>({
            options,
            findFuzzyTz
        }), [
        findFuzzyTz,
        options
    ]);
};
const TimeZonePicker = (param)=>{
    let { value , onChange , onBlur , className , style , disabled  } = param;
    const { options , findFuzzyTz  } = useTimeZones();
    const { reference , floating , x , y , strategy , refs  } = (0,floating_ui_react_dom_interactions_esm/* useFloating */.YF)({
        strategy: "fixed",
        middleware: [
            (0,floating_ui_core_browser_min/* offset */.cv)(5),
            (0,floating_ui_core_browser_min/* flip */.RR)(),
            (0,floating_ui_core_browser_min/* size */.dp)({
                apply: (param)=>{
                    let { rects  } = param;
                    if (refs.floating.current) {
                        Object.assign(refs.floating.current.style, {
                            width: "".concat(rects.reference.width, "px")
                        });
                    }
                }
            })
        ]
    });
    const timeZoneOptions = react.useMemo(()=>[
            {
                value: "",
                label: "Ignore time zone",
                offset: 0
            },
            ...options
        ], [
        options
    ]);
    var _timeZoneOptions_find;
    const selectedTimeZone = react.useMemo(()=>value ? (_timeZoneOptions_find = timeZoneOptions.find((timeZoneOption)=>timeZoneOption.value === value)) !== null && _timeZoneOptions_find !== void 0 ? _timeZoneOptions_find : findFuzzyTz(value) : timeZoneOptions[0], [
        findFuzzyTz,
        timeZoneOptions,
        value
    ]);
    const [query, setQuery] = react.useState("");
    const filteredTimeZones = react.useMemo(()=>{
        return query ? timeZoneOptions.filter((tz)=>{
            if (tz.label.toLowerCase().includes(query.toLowerCase())) {
                return true;
            }
            const tzStrings = (0,timezone_soft/* default */.Z)(query);
            return tzStrings.some((tzString)=>tzString.iana === tz.value);
        }) : timeZoneOptions;
    }, [
        timeZoneOptions,
        query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(combobox/* Combobox */.h, {
        value: selectedTimeZone,
        onChange: (newTimeZone)=>{
            setQuery("");
            onChange(newTimeZone.value);
        },
        disabled: disabled,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("relative", className),
            ref: reference,
            style: style,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(combobox/* Combobox.Input */.h.Input, {
                    className: "input w-full pr-8",
                    displayValue: ()=>"",
                    onChange: (e)=>{
                        setQuery(e.target.value);
                    },
                    onBlur: onBlur
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(combobox/* Combobox.Button */.h.Button, {
                    className: "absolute inset-0 flex h-9 w-full cursor-default items-center px-2 text-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "grow truncate",
                            children: !query ? selectedTimeZone.label : null
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "pointer-events-none flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_down/* default */.Z, {
                                className: "h-5 w-5"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(floating_ui_react_dom_interactions_esm/* FloatingPortal */.ll, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(combobox/* Combobox.Options */.h.Options, {
                        ref: floating,
                        className: "z-50 mt-1 max-h-72 overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none",
                        style: {
                            position: strategy,
                            left: x !== null && x !== void 0 ? x : "",
                            top: y !== null && y !== void 0 ? y : ""
                        },
                        children: filteredTimeZones.map((timeZone)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(combobox/* Combobox.Option */.h.Option, {
                                className: menu_styles/* styleMenuItem */.N,
                                value: timeZone,
                                children: timeZone.label
                            }, timeZone.value))
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var time_zone_picker = (TimeZonePicker);

;// CONCATENATED MODULE: ./src/components/time-zone-picker/index.ts



/***/ }),

/***/ 5596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_new; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(2031);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(692);
// EXTERNAL MODULE: ./node_modules/posthog-js/dist/es.js
var es = __webpack_require__(9893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-use/esm/misc/util.js
var util = __webpack_require__(6362);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/useSessionStorage.js


var useSessionStorage = function (key, initialValue, raw) {
    if (!util/* isBrowser */.jU) {
        return [initialValue, function () { }];
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _a = (0,react.useState)(function () {
        try {
            var sessionStorageValue = sessionStorage.getItem(key);
            if (typeof sessionStorageValue !== 'string') {
                sessionStorage.setItem(key, raw ? String(initialValue) : JSON.stringify(initialValue));
                return initialValue;
            }
            else {
                return raw ? sessionStorageValue : JSON.parse(sessionStorageValue || 'null');
            }
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // sessionStorage can throw. JSON.parse and JSON.stringify
            // can throw, too.
            return initialValue;
        }
    }), state = _a[0], setState = _a[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0,react.useEffect)(function () {
        try {
            var serializedState = raw ? String(state) : JSON.stringify(state);
            sessionStorage.setItem(key, serializedState);
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // sessionStorage can throw. Also JSON.stringify can throw.
        }
    });
    return [state, setState];
};
/* harmony default export */ var esm_useSessionStorage = (useSessionStorage);

// EXTERNAL MODULE: ./src/utils/date-time-utils.ts
var date_time_utils = __webpack_require__(5422);
// EXTERNAL MODULE: ./src/utils/trpc.ts + 63 modules
var trpc = __webpack_require__(3757);
// EXTERNAL MODULE: ./src/components/button.tsx
var components_button = __webpack_require__(5295);
// EXTERNAL MODULE: ./src/components/forms/index.ts + 2 modules
var components_forms = __webpack_require__(1095);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
;// CONCATENATED MODULE: ./src/components/steps/steps.tsx




const Steps = (param)=>{
    let { current , total , className  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("app");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("inline-flex items-center", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-sm font-medium tracking-tight",
                children: t("stepSummary", {
                    current: current + 1,
                    total
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ml-2 flex items-center",
                children: [
                    ...Array(total)
                ].map((_, i)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,clsx_m/* default */.Z)("ml-3 h-2  w-2 rounded-full transition-all", {
                            "bg-primary-400": i <= current,
                            "bg-gray-300": i > current,
                            "ring-primary-200 animate-pulse ring-4": i === current
                        })
                    }, i);
                })
            })
        ]
    });
};
/* harmony default export */ var steps = (Steps);

;// CONCATENATED MODULE: ./src/components/steps/index.ts


// EXTERNAL MODULE: ./src/components/user-provider.tsx
var user_provider = __webpack_require__(7348);
;// CONCATENATED MODULE: ./src/components/create-poll.tsx












const create_poll_steps = [
    "eventDetails",
    "options",
    "userDetails"
];
const required = (v)=>{
    if (!v) {
        throw new Error("Required value is missing");
    }
    return v;
};
const initialNewEventData = {
    currentStep: 0
};
const sessionStorageKey = "newEventFormData";
const Page = (param)=>{
    let { title , location , description , view  } = param;
    var _session_user;
    const { t  } = (0,esm/* useTranslation */.$G)("app");
    const router = (0,next_router.useRouter)();
    const session = (0,user_provider/* useUser */.aF)();
    const [persistedFormData, setPersistedFormData] = esm_useSessionStorage(sessionStorageKey, {
        currentStep: 0,
        eventDetails: {
            title,
            location,
            description
        },
        options: {
            view
        },
        userDetails: ((_session_user = session.user) === null || _session_user === void 0 ? void 0 : _session_user.isGuest) === false ? {
            name: session.user.name,
            contact: session.user.email
        } : undefined
    });
    const [formData, setTransientFormData] = react.useState(persistedFormData);
    const setFormData = react.useCallback((newEventData)=>{
        setTransientFormData(newEventData);
        setPersistedFormData(newEventData);
    }, [
        setPersistedFormData
    ]);
    var _formData_currentStep;
    const currentStepIndex = (_formData_currentStep = formData === null || formData === void 0 ? void 0 : formData.currentStep) !== null && _formData_currentStep !== void 0 ? _formData_currentStep : 0;
    const currentStepName = create_poll_steps[currentStepIndex];
    const [isRedirecting, setIsRedirecting] = react.useState(false);
    const createPoll = trpc/* trpc.useMutation */.S.useMutation([
        "polls.create"
    ], {
        onSuccess: (res)=>{
            var _formData_options, _formData_options_options, _formData_options1;
            setIsRedirecting(true);
            es/* default.capture */.ZP.capture("created poll", {
                numberOfOptions: (_formData_options = formData.options) === null || _formData_options === void 0 ? void 0 : (_formData_options_options = _formData_options.options) === null || _formData_options_options === void 0 ? void 0 : _formData_options_options.length,
                optionsView: formData === null || formData === void 0 ? void 0 : (_formData_options1 = formData.options) === null || _formData_options1 === void 0 ? void 0 : _formData_options1.view
            });
            setPersistedFormData(initialNewEventData);
            router.replace("/admin/".concat(res.urlId));
        }
    });
    const isBusy = isRedirecting || createPoll.isLoading;
    const handleSubmit = async (data)=>{
        if (currentStepIndex < create_poll_steps.length - 1) {
            setFormData({
                ...formData,
                currentStep: currentStepIndex + 1,
                [currentStepName]: data
            });
        } else {
            var _formData_eventDetails, _formData_eventDetails1, _formData_eventDetails2, _formData_userDetails, _formData_userDetails1, _formData_options, _formData_options1;
            // last step
            const title = required(formData === null || formData === void 0 ? void 0 : (_formData_eventDetails = formData.eventDetails) === null || _formData_eventDetails === void 0 ? void 0 : _formData_eventDetails.title);
            await createPoll.mutateAsync({
                title: title,
                type: "date",
                location: formData === null || formData === void 0 ? void 0 : (_formData_eventDetails1 = formData.eventDetails) === null || _formData_eventDetails1 === void 0 ? void 0 : _formData_eventDetails1.location,
                description: formData === null || formData === void 0 ? void 0 : (_formData_eventDetails2 = formData.eventDetails) === null || _formData_eventDetails2 === void 0 ? void 0 : _formData_eventDetails2.description,
                user: {
                    name: required(formData === null || formData === void 0 ? void 0 : (_formData_userDetails = formData.userDetails) === null || _formData_userDetails === void 0 ? void 0 : _formData_userDetails.name),
                    email: required(formData === null || formData === void 0 ? void 0 : (_formData_userDetails1 = formData.userDetails) === null || _formData_userDetails1 === void 0 ? void 0 : _formData_userDetails1.contact)
                },
                timeZone: formData === null || formData === void 0 ? void 0 : (_formData_options = formData.options) === null || _formData_options === void 0 ? void 0 : _formData_options.timeZone,
                options: required(formData === null || formData === void 0 ? void 0 : (_formData_options1 = formData.options) === null || _formData_options1 === void 0 ? void 0 : _formData_options1.options).map(date_time_utils/* encodeDateOption */.D9)
            });
        }
    };
    const handleChange = (data)=>{
        setFormData({
            ...formData,
            currentStep: currentStepIndex,
            [currentStepName]: data
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "max-w-full px-3 pb-3 sm:p-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "max-w-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-full overflow-hidden rounded-lg border bg-white shadow-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between border-b p-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "m-0 text-xl font-semibold text-slate-800",
                                children: t("createNew")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(steps, {
                                current: currentStepIndex,
                                total: create_poll_steps.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            (()=>{
                                switch(currentStepName){
                                    case "eventDetails":
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_forms/* PollDetailsForm */.sJ, {
                                            className: "max-w-full p-3 sm:p-4",
                                            name: currentStepName,
                                            defaultValues: formData === null || formData === void 0 ? void 0 : formData.eventDetails,
                                            onSubmit: handleSubmit,
                                            onChange: handleChange
                                        });
                                    case "options":
                                        var _formData_eventDetails;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_forms/* PollOptionsForm */.yt, {
                                            className: "grow",
                                            name: currentStepName,
                                            defaultValues: formData === null || formData === void 0 ? void 0 : formData.options,
                                            onSubmit: handleSubmit,
                                            onChange: handleChange,
                                            title: (_formData_eventDetails = formData.eventDetails) === null || _formData_eventDetails === void 0 ? void 0 : _formData_eventDetails.title
                                        });
                                    case "userDetails":
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_forms/* UserDetailsForm */.CO, {
                                            className: "grow p-4",
                                            name: currentStepName,
                                            defaultValues: formData === null || formData === void 0 ? void 0 : formData.userDetails,
                                            onSubmit: handleSubmit,
                                            onChange: handleChange
                                        });
                                }
                            })(),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex w-full justify-end space-x-3 border-t bg-slate-50 px-4 py-3",
                                children: [
                                    currentStepIndex > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* Button */.z, {
                                        disabled: isBusy,
                                        onClick: ()=>{
                                            setFormData({
                                                ...persistedFormData,
                                                currentStep: currentStepIndex - 1
                                            });
                                        },
                                        children: t("back")
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_button/* Button */.z, {
                                        form: currentStepName,
                                        loading: isBusy,
                                        htmlType: "submit",
                                        type: "primary",
                                        children: currentStepIndex < create_poll_steps.length - 1 ? t("continue") : t("createPoll")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var create_poll = (Page);

// EXTERNAL MODULE: ./src/components/layouts/standard-layout.tsx + 15 modules
var standard_layout = __webpack_require__(3085);
;// CONCATENATED MODULE: ./src/pages/new.tsx





const new_Page = ()=>{
    const { t  } = (0,useTranslation/* useTranslation */.$)("app");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: t("createNew")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex,nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(create_poll, {})
        ]
    });
};
new_Page.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(standard_layout/* default */.Z, {
        children: page
    });
};
var __N_SSP = true;
/* harmony default export */ var pages_new = (new_Page);


/***/ }),

/***/ 5422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ expectTimeOption; },
/* harmony export */   "D9": function() { return /* binding */ encodeDateOption; },
/* harmony export */   "YX": function() { return /* binding */ decodeOptions; },
/* harmony export */   "ZP": function() { return /* binding */ getDateProps; },
/* harmony export */   "eU": function() { return /* binding */ removeAllOptionsForDay; },
/* harmony export */   "ei": function() { return /* binding */ getBrowserTimeZone; },
/* harmony export */   "g9": function() { return /* binding */ getDuration; }
/* harmony export */ });
/* unused harmony export parseValue */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

const getBrowserTimeZone = ()=>Intl.DateTimeFormat().resolvedOptions().timeZone;
const encodeDateOption = (option)=>{
    return option.type === "timeSlot" ? "".concat(option.start, "/").concat(option.end) : option.date;
};
const isTimeSlot = (value)=>value.indexOf("/") !== -1;
const getDuration = (startTime, endTime)=>{
    const hours = Math.floor(endTime.diff(startTime, "hours"));
    const minutes = Math.floor(endTime.diff(startTime, "minute") - hours * 60);
    let res = "";
    if (hours) {
        res += "".concat(hours, "h");
    }
    if (hours && minutes) {
        res += " ";
    }
    if (minutes) {
        res += "".concat(minutes, "m");
    }
    return res;
};
const decodeOptions = (options, timeZone, targetTimeZone, // eslint-disable-next-line @typescript-eslint/no-unused-vars
_timeFormat)=>{
    const pollType = isTimeSlot(options[0].value) ? "timeSlot" : "date";
    if (pollType === "timeSlot") {
        return {
            pollType,
            options: options.map((option)=>parseTimeSlotOption(option, timeZone, targetTimeZone))
        };
    } else {
        return {
            pollType,
            options: options.map((option)=>parseDateOption(option))
        };
    }
};
const parseDateOption = (option)=>{
    const dateString = option.value.indexOf("T") === -1 ? option.value + "T00:00:00" : option.value;
    const date = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateString);
    return {
        type: "date",
        optionId: option.id,
        day: date.format("D"),
        dow: date.format("ddd"),
        month: date.format("MMM"),
        year: date.format("YYYY")
    };
};
const parseTimeSlotOption = (option, timeZone, targetTimeZone)=>{
    const [start, end] = option.value.split("/");
    const startDate = timeZone && targetTimeZone ? dayjs__WEBPACK_IMPORTED_MODULE_0___default()(start).tz(timeZone, true).tz(targetTimeZone) : dayjs__WEBPACK_IMPORTED_MODULE_0___default()(start);
    const endDate = timeZone && targetTimeZone ? dayjs__WEBPACK_IMPORTED_MODULE_0___default()(end).tz(timeZone, true).tz(targetTimeZone) : dayjs__WEBPACK_IMPORTED_MODULE_0___default()(end);
    return {
        type: "timeSlot",
        optionId: option.id,
        startTime: startDate.format("LT"),
        endTime: endDate.format("LT"),
        day: startDate.format("D"),
        dow: startDate.format("ddd"),
        month: startDate.format("MMM"),
        duration: getDuration(startDate, endDate),
        year: startDate.format("YYYY")
    };
};
const removeAllOptionsForDay = (options, date)=>{
    return options.filter((option)=>{
        return !dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).isSame(option.type === "date" ? option.date : option.start, "day");
    });
};
const getDateProps = (date)=>{
    const d = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date);
    return {
        day: d.format("D"),
        dow: d.format("ddd"),
        month: d.format("MMM")
    };
};
const expectTimeOption = (d)=>{
    if (d.type === "date") {
        throw new Error("Expected timeSlot but got date instead");
    }
    return d;
};
const parseValue = (value)=>{
    if (isTimeSlot(value)) {
        const [start, end] = value.split("/");
        return {
            type: "timeSlot",
            start,
            end
        };
    } else {
        return {
            type: "date",
            date: value
        };
    }
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [160,1664,428,5999,3255,6247,5910,5061,3085,1095,9774,2888,179], function() { return __webpack_exec__(877); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);